import axios from "@/api/axiosInstance";
import { SystemFolderKey, SystemFolderResponse } from "./types";

/**
 * Resolve a File Manager namespace folder (Campaign / Resource Library /
 * Email Template / Employee Directory) to its UUID for the active company.
 * Used by feature pages that want to open FilePickerDialog directly inside
 * their feature folder.
 */
export const getSystemFolder = async (
  key: SystemFolderKey,
): Promise<SystemFolderResponse> => {
  const response = await axios.get<SystemFolderResponse>(
    `/api/private/file-management/folders/system/${key}`,
  );
  return response.data;
};
